import { render, staticRenderFns } from "./header.vue?vue&type=template&id=acaf26e6&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmtkpv/Projects/barcode-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('acaf26e6', component.options)
    } else {
      api.reload('acaf26e6', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=acaf26e6&", function () {
      api.rerender('acaf26e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/routes/template/header.vue"
export default component.exports